import { render } from "./update-notification.vue?vue&type=template&id=712f4252&scoped=true&ts=true"
import script from "./update-notification.vue?vue&type=script&lang=ts"
export * from "./update-notification.vue?vue&type=script&lang=ts"

import "./update-notification.vue?vue&type=style&index=0&id=712f4252&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712f4252"]])

export default __exports__